module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "scaleUp"
    }
  }, [_c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.addSubject),
      expression: "addSubject"
    }],
    staticClass: "subject",
    style: ({
      'background-color': _vm.subject.color
    })
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hours),
      expression: "hours"
    }],
    ref: "count",
    staticClass: "subject__input-number",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.hours)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addSubject.apply(null, arguments)
      },
      "focus": _vm.selectAll,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hours = $event.target.value
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f998cac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubjectsDistribution/BulkCreateSubjectsSubject.vue
// module id = 1838
// module chunks = 1